import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ChartProps {
  data: any[];
}

const Chart: React.FC<ChartProps> = ({ data }) => {
  return (
    <div 
      className="h-72 sm:h-96 mt-4"
      role="region"
      aria-label="Investment growth chart"
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart 
          data={data} 
          margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
          aria-label="Line chart showing investment growth over time"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="year" 
            name="Year"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => `${value}`}
            aria-label="Years"
          />
          <YAxis 
            tickFormatter={(value) => `$${(value / 1000)}k`}
            tick={{ fontSize: 12 }}
            width={60}
            aria-label="Value in thousands of dollars"
          />
          <Tooltip
            formatter={(value: number) => [`$${value.toLocaleString()}`, '']}
            labelFormatter={(label) => `Year ${label}`}
            contentStyle={{ fontSize: '12px' }}
          />
          <Line
            type="monotone"
            dataKey="balance"
            stroke="#059669"
            strokeWidth={2}
            name="Balance"
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="contributed"
            stroke="#047857"
            strokeWidth={2}
            name="Contributed"
            dot={false}
          />
          {data[0]?.employer && (
            <Line
              type="monotone"
              dataKey="employer"
              stroke="#065f46"
              strokeWidth={2}
              name="Employer Match"
              dot={false}
            />
          )}
          {data[0]?.dividends && (
            <Line
              type="monotone"
              dataKey="dividends"
              stroke="#064e3b"
              strokeWidth={2}
              name="Dividends"
              dot={false}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;